import axios from "axios";

export async function upgradeUser(email) {
  try {
    // 1️⃣ Check if email exists
    const checkResponse = await axios.get(
      `${process.env.REACT_APP_PAYMENT_BASE}v1/stripe/pending`,
      { params: { email } }
    );

    const data = checkResponse.data;
    if (!data.developer_id) {
      console.log("User email does not exist.");
      return { success: false, error: "No developer_id found" };
    }

    const developerId = data.developer_id;

    // 2️⃣ Upgrade to premium
    let premiumSuccess = false;
    try {
      const premiumResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}v7/user/webflow/upgrade/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "no-encryption": "True",
          },
        }
      );

      if (premiumResponse.status === 200) {
        console.log("User upgraded to premium successfully.");
        premiumSuccess = true;
      }
    } catch (err) {
      console.error("Failed to upgrade user to premium:", err.response?.data || err.message);
    }

    // 3️⃣ Only delete developer record if premium succeeded
    if (premiumSuccess) {
      try {
        await axios.delete(`${process.env.REACT_APP_PAYMENT_BASE}v1/stripe/pending`, {
          params: { developer_id: developerId },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        console.log("Developer record deleted successfully.");
      } catch (err) {
        console.error("Failed to delete developer record:", err.response?.data || err.message);
      }
    }

    return { success: premiumSuccess };
  } catch (error) {
    console.error("Error in user upgrade flow:", error);
    return { success: false, error: error.message };
  }
}

export async function handleLogin(email, password) {
  const data = new FormData();
  data.append("grant_type", "password");
  data.append("username", email);
  data.append("password", password);
  data.append("guest.developer_id", "a636b2c8-3cbe-4d1d-bf42-198b54bc080d");
  data.append("device.device_id", "628E7017-2307-454A-9874-21B452CB4770");
  data.append("client_secret", "VfsYbPZg4nQAP4xOohoqyAV8rGaEgGTTvUP1oxKUaKcfEafoewQ0RHTj1c6c9VkCOu71ByeLU9fi1WOvQMgBewlceHlejGXbi510RMOAd6YvHgw9vDf32YMOCNVy1AvZ");
  data.append("client_id", "AiWaiUrd6zx0BPSDjx0h6jstz0BpSbbOyrTWkkAD");

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}v7/user/email/login/`,
      data,
      {
        headers: { "no-encryption": "True" },
      }
    );

    localStorage.setItem("access_token", response.data.access_token);
    localStorage.setItem("refresh_token", response.data.refresh_token);
    localStorage.setItem("developer_id", response.data.developer_id);
    localStorage.setItem("user_id", response.data.user_id);
    localStorage.setItem("profile_id", response.data.profile_id);
    localStorage.setItem("userEmail", email);

    console.log("Login successful:", response.data);

    return { success: true };
  } catch (error) {
    console.error("Login failed: ", error.response?.data || error.message);
    return { success: false, error: error.message };
  }
}